import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 offset-md-3" }

import { ref, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields } from "@/plugins/ws";

import {RootState} from "@/store";

interface RestoreFinishPayload {
  idUser: number;
  name: string;
  email: string;
  theme: string;
  admin: boolean;
  confirmEmail: boolean;
  register: Record<string, unknown>;
  newPassword: Record<string, unknown>;
  restorePassword: Record<string, unknown>;
}

type RestoreSetPasswordFinishMessage = WebSocketMessageWithFields<'auth-restore-set-password-finish', {
  auth: {
    idUser: number;
    name: string;
    email: string;
    theme: string;
    admin: boolean;
    confirmEmail: boolean;
    register: Record<string, unknown>;
    newPassword: Record<string, unknown>;
    restorePassword: Record<string, unknown>;
  };
}>;

// Объединенный тип для всех сообщений
type RestoreSuccessWebSocketMessageType = RestoreSetPasswordFinishMessage;


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ComponentsAuthRestoreSuccess',
},
  __name: 'RestoreSuccess',
  emits: ["resubscribePage", "switchMode"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const store = useStore<RootState>();

// Типы для WebSocket сообщений компонента RestoreSuccess
const internalInstance = getCurrentInstance();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const wsSend = internalInstance?.appContext.config.globalProperties.$wsSend as (signal: string, payload?: any) => void;

const latestMessageValue = ref(latestMessage);

// WebSocket message handler
const handleWebSocketMessage = (data: RestoreSuccessWebSocketMessageType): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'auth-restore-set-password-finish':
      signalRestoreFinish({
        idUser: data.auth.idUser,
        name: data.auth.name,
        theme: data.auth.theme,
        email: data.auth.email,
        admin: data.auth.admin,
        confirmEmail: data.auth.confirmEmail,
        register: data.auth.register,
        newPassword: data.auth.newPassword,
        restorePassword: data.auth.restorePassword,
      });
      break;
  }
};

watch(latestMessageValue, handleWebSocketMessage);

const handleClickActionRestoreFinish = () => {
  wsSend('authRestoreSetPasswordFinish');
  emit('resubscribePage');
};

const signalRestoreFinish = (payload: RestoreFinishPayload) => {
  store.dispatch('auth/wsSetUser', payload);
  emit('switchMode', 'login');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "login-form mt-4 p-4" }, [
      _createElementVNode("div", { class: "row g-3" }, [
        _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Восстановление завершено", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("p", null, "Установлен новый пароль", -1)),
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-dark float-end ms-3",
            onClick: handleClickActionRestoreFinish
          }, "Продолжить")
        ])
      ])
    ])
  ]))
}
}

})